import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
interface ReportData {
    serial: number;
    id: number;
    file_name: string;
    bank: string,
    query: string,
}
interface AllProps {
    reports: ReportData[];
    redirectToDashboard?: any;
}
export default class VettingReportTable extends Component<AllProps> {
    render() {
        const { reports = [], redirectToDashboard = () => { } } = this.props;
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return (
            <div className="">
                <div className="dt-responsive table-responsive" style={{ overflow: 'auto' }}>
                    <table style={{ overflowX: "scroll", width: "100%" }} id="processeodTable" className="table table-striped table-bordered nowrap">
                        <thead>
                            <tr>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Sl.No</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File No</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Vetting Officer</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>File Status</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Login Date</th>
                                <th style={{ position: 'sticky', top: 0, background: 'white' }}>Update Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reports && reports.length
                                ? reports.map(
                                    (query: any, index: number) => {
                                        return (
                                            <tr className="query-table-row cursor-pointer" key={index}>
                                                <td className="text-align-center">{index + 1}</td>
                                                <td className="click text-align-center"> {query.file_name ? query.file_name : ""}</td>
                                                <td className="click text-align-center">{query.vetting_by}</td>
                                                <td className="click text-align-center">{query.status}</td>
                                                <td className="click text-align-center">{query.login_date}</td>
                                                <td className="click text-align-center">{query.updated_dt}</td>
                                            </tr>
                                        );
                                    }
                                ) : ""}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
